<template>
  <span @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <Teleport v-if="mounted" to="body">
      <div
        :id="`tooltip-${randomNumber}`"
        class="absolute z-[999] opacity-0 bg-[#2B2B30] dark:bg-white dark:text-blue-700 text-white text-xs py-1 px-2 rounded pointer-events-none transition-all duration-300 w-max max-w-[300px] text-center group-hover/tooltip:opacity-100"
      >
        <!--         after:absolute after:w-2.5 after:h-2.5 after:rotate-45 after:rounded-sm after:bg-[#2B2B30] dark:after:bg-white -->
        {{ text }}
      </div>
    </Teleport>
  </span>
</template>

<script setup lang="ts">
import { useMounted } from "@vueuse/core";

interface Props {
  text: string;
  position?: "top" | "bottom" | "left" | "right";
}
const props = defineProps<Props>();

const mounted = useMounted();

const randomNumber = Math.floor(Math.random() * 101);
// const tailPosition = computed(() => {
//   switch (props.position) {
//     case 'top':
//       return 'after:left-1/2 after:-translate-x-1/2 after:-bottom-1'
//     case 'bottom':
//       return 'after:left-1/2 after:-translate-x-1/2 after:-top-1 after:rotate-180'
//     case 'left':
//       return 'after:left-1/2 after:-translate-x-1/2'
//     case 'right':
//       return 'after:left-1/2 after:-translate-x-1/2'
//   }
// })
function showTooltip(event) {
  const target = event.currentTarget;
  const tooltipPosition = props.position || "top";

  const tooltip = document.getElementById(`tooltip-${randomNumber}`)!;
  const rect = target.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();

  let top, left;

  switch (tooltipPosition) {
    case "bottom":
      top = rect.bottom + 5;
      left = rect.left + rect.width / 2 - tooltipRect.width / 2;
      break;
    case "left":
      top =
        rect.top + window.scrollY + rect.height / 2 - tooltipRect.height / 2;
      left = rect.left - tooltipRect.width - 5;
      break;
    case "right":
      top =
        rect.top + window.scrollY + rect.height / 2 - tooltipRect.height / 2;
      left = rect.right + 5;
      break;
    case "top":
    default:
      top = rect.top + window.scrollY - tooltipRect.height - 5;
      left = rect.left + rect.width / 2 - tooltipRect.width / 2;
      break;
  }

  // Adjust if out of bounds
  if (top < window.scrollY) {
    top = rect.bottom + 5;
  }
  if (top + tooltipRect.height > window.scrollY + window.innerHeight) {
    top = rect.top + window.scrollY - tooltipRect.height - 5;
  }
  if (left < window.scrollX) {
    left = window.scrollX;
  }
  if (left + tooltipRect.width > window.scrollX + window.innerWidth) {
    left = window.scrollX + window.innerWidth - tooltipRect.width;
  }

  // Apply positions
  tooltip.style.top = `${top}px`;
  tooltip.style.left = `${left}px`;
  tooltip.classList.add("opacity-100");
}
function hideTooltip() {
  const tooltip = document.getElementById(`tooltip-${randomNumber}`)!;
  tooltip.classList.remove("opacity-100");
}
</script>
